import type { FormStatsQuery } from '@troia-v3/types';
import { useQuery } from '@tanstack/react-query';
import { formsApi } from '../services/formsApi';

export const useFormStats = (formId?: string, query?: FormStatsQuery) => {
  return useQuery({
    queryKey: ['form-stats', formId, query],
    queryFn: () => formsApi.getStats(formId!, query),
    enabled: !!formId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
